import React from 'react';
import PropTypes from 'prop-types';

import BulkServe from 'PointOfSale/modules/cepCard/component/BulkServe';
import { getValue } from 'Common/Components/Keyboard/withKeyboard';

import 'PointOfSale/styles/components/cepCard.less';

class BulkServeContainer extends React.Component {
  state = {
    bulkServeCount: '',
    placeHolderText: '0',
  };

  bulkServeInputRef = React.createRef();

  onChangeBulkChange = e => {
    let value = getValue(e);
    value = value.replace(/0-9/g, '');

    value = parseInt(value, 10) ? parseInt(value, 10) : '';
    value = Math.abs(value);

    const valueString = value.toString();

    const keyboardInput = this.bulkServeInputRef.current.wrappedInstance;
    keyboardInput.setKeyboardValue(valueString);

    this.setState({
      bulkServeCount: valueString,
    });
  };

  setPlaceholder = text => {
    this.setState({
      placeHolderText: text,
    });
  };

  render() {
    return (
      <BulkServe
        onClickServe={this.props.onClickServe}
        setPlaceholder={this.setPlaceholder}
        placeHolderText={this.state.placeHolderText}
        bulkServeCount={this.state.bulkServeCount}
        onChangeBulkChange={this.onChangeBulkChange}
        forwardedRef={this.bulkServeInputRef}
      />
    );
  }
}

BulkServeContainer.propTypes = {
  onClickServe: PropTypes.func,
};
export default BulkServeContainer;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/container/BulkServeContainer.js